export default class HelpFunctions {
  createConnectionObject (connection, connectionTypes) {
    connection.ID = new Date().getTime()
    connection.connectionTypes = connectionTypes
    connection.connectionType = connectionTypes.filter(function (c) {
      return c._selected
    })[0]
    return connection
  }

  editConnectionObject (connection, connectionTypes) {
    connection.connectionTypes = connectionTypes
    connection.connectionType = connectionTypes.filter(function (c) {
      return c._selected
    })[0]
    return connection
  }

  foutmeldingMaken (res) {
    return 'Foutcode ' + res.status + ' : ' + res.message
  }

  getLoginCallProperties (connection, projectNaam, versieNummer) {
    let callProperties = {
      'action': 'WisaUserAPI',
      'contentType': 'application/json',
      'dataType': 'json',
      'type': 'rpc',
      'tid': '1'
    }
    if (connection.connectionType.type === 'office365') {
      callProperties.method = 'ExternalAuthenticate'
      callProperties.data = ['Office365', connection.username.toLowerCase(), connection.password, projectNaam, versieNummer]
    } else { // (connection.connectionType.type === 'schoolware')
      callProperties.method = 'Authenticate'
      callProperties.data = [connection.username, connection.password, projectNaam, versieNummer]
    }
    return callProperties
  }
}
